import React from 'react';
import { Container } from 'react-bootstrap';
import { PageHeader } from '@features/shared';
import PILSuervey from '@components/PILSurvey/PILSuervey';
import { usePageInitialization } from '@features/shared/hooks/usePageInitialization';

/**
 * PIL Survey Page - Displays PIL survey form
 */
const PILSurveyPage = () => {
  usePageInitialization();

  return (
    <div>
      <PageHeader title="PIL Survey" path="/" />
      <Container style={{ backgroundColor: '#F5F5F5' }}>
        <PILSuervey />
      </Container>
    </div>
  );
};

export { PILSurveyPage };
export default PILSurveyPage;
